import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ImageWithBasePath from '../../../../core/img/imagewithbasebath';
import { ROLL_CALL_API_BASE_URL } from '../RollCallConfig/RollCallConfig';
import CommonFooter from '../../../../core/common/footer/commonFooter';

const RollcallNotification = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [tokenData, setTokenData] = useState(null);
    const [superIdData, setSuperIdData] = useState(null);

    const userData = JSON.parse(sessionStorage.getItem("userData"));

    useEffect(() => {
        const token = sessionStorage.getItem("authToken");
        const superId = sessionStorage.getItem("superId");

        if (token && superId) {
            setTokenData(token);
            setSuperIdData(superId);
        } else {
            console.warn("User data not found in sessionStorage");
            navigate("/signin");
        }
    }, [navigate]);

    useEffect(() => {
        const fetchNotificationData = async () => {
            if (tokenData && superIdData && userData?.RegId) {
                setLoading(true);
                try {
                    const response = await fetch(
                        `${ROLL_CALL_API_BASE_URL}portal/notification/getNotification?superid=${superIdData}&regid=${userData?.RegId}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${tokenData}`,
                            },
                        }
                    );

                    if (!response.ok) {
                        throw new Error("Failed to fetch notifications");
                    }

                    const data = await response.json();
                    if (data.status) {
                        setData(data.ResultData || []);
                    } else {
                        console.error("Error fetching notifications:", data.ErrorMsg);
                    }
                } catch (error) {
                    console.error("Error fetching notifications:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchNotificationData();
    }, [superIdData, tokenData, userData?.RegId]);

    return (
        <div className="page-wrapper">
            <div className="content mb-4">
                <div className="page-header">
                    <div className="page-title">
                        <h4>All Notifications</h4>
                        <h6>View your all Notifications</h6>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center mt-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2 text-muted">Fetching notifications...</p>
                    </div>
                ) : data.length > 0 ? (
                    data.map((item, index) => (
                        <div key={index} className="card mb-3 border shadow-none">
                            <div className="px-3 py-3">
                                <div className="d-flex align-items-center">
                                    <div className="d-flex me-2">
                                        <Link className="avatar avatar-lg avatar-rounded">
                                            <ImageWithBasePath
                                                src="assets/img/customer/profile3.jpg"
                                                alt="User"
                                            />
                                        </Link>
                                    </div>
                                    <div className="flex-grow-1">
                                        <p className="noti-details mb-1">
                                            <span className="noti-title fw-bold">{item.Name}</span> –{" "}
                                            {item.Description}
                                        </p>
                                        <p className="noti-time mb-0 text-muted">
                                            <i className="far fa-clock me-1" />
                                            {new Date(item.CreatedOn).toLocaleString()}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center mt-5">
                        <h6>No notifications found</h6>
                    </div>
                )}
            </div>

            <CommonFooter />
        </div>
    );
};

export default RollcallNotification;
